<!-- 工单动态列表 -->

<template>
  <div>
    <div>
        <h4 style="margin-top:40px;">动态</h4>
    </div>
    <div
        :title="each.ticketTitle + ' ' + each.operateContent + ' ' + (each.assignUserId||'')"
        style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;padding-right:20px;"
        v-for="each in ticketEventList"
        :key="each.id">
        <span>{{each.createdAt|ticketTime}}</span>
        <span style="color:DarkGray;">在工单</span>
        <a :href="'/ticket/t/' + each.orderId" style="color: #409eff;">{{each.ticketTitle || each.orderId}}</a>
        <span>{{each.operateContent}}</span>
        <span v-if="each.assignUserId">
        给
        <TicketUser :userId="each.assignUserId"/>
        </span>
    </div>

    <div v-if="!ticketEventList || ticketEventList.length < 1">ticketEventList is null or empty ...</div>

    <el-pagination
    style="padding-top:20px;"
    background
    layout="total, sizes, prev, pager, next, jumper"
    :pager-count="6"
    :current-page="ticketEventPage.pageNumber" 
    :page-sizes="[10, 25, 35, 50, 100]" 
    :page-size="ticketEventPage.pageSize" 
    :total="ticketEventPage.recordCount || 0" 
    @size-change="handleSizeChange_TicketEvent" 
    @current-change="listTicketEvent" />
  </div>
</template>

<script>
export default {
    name: 'UserTicketEventList',

    props: ['userId'],

    data() {
        return {
            createdAtGe: null,
            createdAtLe: null,

            ticketEventList : [],

            ticketEventPage : {
                pageNumber: 1,
                pageSize: 20,
                orderBy: "`create_time` DESC"
            }
      }
    },

    watch: {
        userId() {
            this.listTicketEvent(1);
        }
    },

    methods: {
        handleSizeChange_TicketEvent( pageSize ) {
            this.ticketEventPage.pageSize = pageSize;

            this.listTicketEvent();
        },

        listTicketEvent( _pageNumber ) {
            if ( !this.userId ) {
                console.log('#71 listTicket this.userId = ', this.userId);
                return;
            }

            var _this = this;
            _this.ticketEventPage.pageNumber = _pageNumber;

            sdk.TicketEventApi().listByUserIdAndOrganizationCreatedAtRange({
                userId : 'ALL' != _this.userId ? _this.userId : null,
                page : _this.ticketEventPage,
                createdAtGe: _this.createdAtGe,
                createdAtLe: _this.createdAtLe
            }).then(res => {
                _this.ticketEventList = res.list;
                _this.ticketEventPage.recordCount = res.recordCount;
            });
        },

        listTicketEvent_1(createdAtGe, createdAtLe) {
            this.createdAtGe = createdAtGe;
            this.createdAtLe = createdAtLe;

            this.listTicketEvent(1);
        }
    },

    mounted() {
        this.listTicketEvent(1);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/UserTicketEventList.vue